<template>

    <SubHeader title="Fiche secteur" :breads="[{ name: 'Modifier Secteur' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="prepareSubmit(data)">

                <div class="row">
                    <div class="col-md-12">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" name="label" id="label" v-model="item.label" class="form-control" placeholder="Secteur">
                                </div>
                          
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label"  for="division">Division</label>
                                    <m-select v-model="item.division" :loading="divisionIsLoading"  :required="true" :options="divisionItems" :searchable="false" 
                                        placeholder="Type de division" track-by="id" label="label" >
                                    </m-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Modifier</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import {mapFields} from "vuex-map-fields"
import {mapActions} from "vuex"

export default {
    name: "AdminConfigShowSecteur",
    components: {
        SubHeader
    },
    data(){
        return{
            dataAccept: ["id","division","label"],
        }
    },
    computed: {
        ...mapFields("secteur/show", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            item: "item",

        }),
        ...mapFields("division/list", {
            divisionIsLoading: "isLoading",
            divisionIsSuccess: "isSuccess",
            divisionShowMessage: "showMessage",
            divisionMessage: "message",
            divisionItems: "items"

        }),
        ...mapFields("secteur/update", {
            isUpdated: "isUpdated",
           

        })
    },

    methods: {
        ...mapActions({
            handleSubmit: "secteur/update/update",
            reset: "secteur/update/resetData",
            getDivisions: "division/list/getAll",
            getSecteur: "secteur/show/getOne",
            
        }),
        prepareSubmit(){
            var backData = {}
            this.dataAccept.forEach(it => {
                if("division" == it ){
                    backData["division_id"]  = this.item[it]?.id ?? null
                    
                } else{
                    backData[it]  = this.item[it]
                }
            });
            this.handleSubmit(backData)

        }
    },
    watch:{
    
        isUpdated(val){
            if(val){
                this.$router.push({name:'AdminConfigSecteur'})
            }
        }
    },

    unmounted() {
        this.reset()
    },
    mounted() {
        this.getSecteur(this.$route.params.id ?? 0)
        this.getDivisions()
    }
}
</script>
